// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const deeperResearchClient = createTypedClient();
export const createDeeperResearchClient = (config) => createTypedClient(config);
